import { render, staticRenderFns } from "./MetalTextDefault.vue?vue&type=template&id=7e0d8334&scoped=true"
import script from "./MetalTextDefault.vue?vue&type=script&lang=js"
export * from "./MetalTextDefault.vue?vue&type=script&lang=js"
import style0 from "./MetalTextDefault.vue?vue&type=style&index=0&id=7e0d8334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0d8334",
  null
  
)

export default component.exports